import React, { useContext } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import classNames from 'classnames';
import { useParams } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import useGetReleaseNotes from '../services/useGetReleaseNotes';
import PageLoader from '../components/PageLoader';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

function ViewVersionDetail() {
    const { id } = useParams();
    const { user } = useContext(UserContext);

    const {
        getAllReleaseNote,
        getAllReleaseNoteLoading,
    } = useGetReleaseNotes(id);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        return dateString.split("T")[0];
    };
    return (
        <>
            <Row className='p-2'>
                <Col className="d-flex align-items-center" style={{ gap: '10px' }}>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 bg-transparent p-0">
                            <li className="breadcrumb-item">
                                <Link to="/info/view-all-versions" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                }}>
                                    <MdOutlineKeyboardBackspace
                                        style={{
                                            cursor: 'pointer',
                                            fontSize: '20px',

                                        }}
                                    />
                                    <p style={{ marginBottom: '0px' }}>
                                        All Versions</p>
                                </Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                 Release Notes
                            </li>
                        </ol>
                    </nav>
                </Col>
            </Row>

            <Row className="justify-content-center mt-3">
                <Col md={10} lg={10} xl={8}>
                    {getAllReleaseNoteLoading && <PageLoader />}

                    {!getAllReleaseNoteLoading &&
                        getAllReleaseNote?.length === 0 && (
                            <div className="text-center text-muted mt-4">
                                No release notes available.
                            </div>
                        )}

                    {!getAllReleaseNoteLoading &&
                        getAllReleaseNote
                            ?.filter(note =>
                                !note.pharmUserOnly ||
                                user?.userType === 'PharmacyUser'
                            )
                            .map((note) => (
                                <Card key={note.id} className="ribbon-box mb-3">
                                    <CardBody>
                                        <div className={classNames('ribbon ribbon-primary float-left')}>
                                            {note.type} - ID: {note.id}
                                        </div>
                                        {note.pharmUserOnly && (
                                            <div className="ribbon ribbon-primary mt-2">
                                                Admin Only
                                            </div>
                                        )}
                                          <div
                                                className="d-flex justify-content-end align-items-center mb-2"
                                                style={{ gap: '8px' }}
                                            >
                                                <h5 className="mr-2">{note.title}</h5>
                                            </div>
                                        <div
                                            className="ribbon-content"
                                            dangerouslySetInnerHTML={{ __html: note.description }}
                                        />
                                        <hr />
                                        <div className="text-muted">
                                            {formatDate(note.date)} — By {note.author}
                                        </div>
                                    </CardBody>
                                </Card>
                            ))}
                </Col>
            </Row>
        </>
    );
}

export default ViewVersionDetail;
